// My Work (RCS-134): each sidebar item is its own real, filtered page — not
// one consolidated view — but they all share the one MyWorkModuleList.vue
// page, the same "config array + one shared page" pattern already used for
// Reporting suites (see reportingSuites.ts) and Config & Control Centre.
export interface MyWorkSourceConfig {
  routeName: string;
  path: string;
  label: string;
  // Matches MyWorkController's ?tab= param.
  tab: "assigned" | "approvals" | "reviews";
  // Matches MyWorkService's per-module `source` key — omitted for the
  // approvals/reviews tabs, which are inherently cross-module.
  source?: string;
  emptyDescription: string;
}

export const MY_WORK_SOURCES: MyWorkSourceConfig[] = [
  {
    routeName: "my-work.risks",
    path: "/my-work/risks",
    label: "Assigned Risks",
    tab: "assigned",
    source: "risk",
    emptyDescription: "No risks are currently assigned to you.",
  },
  {
    routeName: "my-work.compliance-actions",
    path: "/my-work/compliance-actions",
    label: "Compliance Actions",
    tab: "assigned",
    source: "obligation",
    emptyDescription: "No compliance obligations are currently assigned to you.",
  },
  {
    routeName: "my-work.investigations",
    path: "/my-work/investigations",
    label: "Investigations",
    tab: "assigned",
    source: "investigation",
    emptyDescription: "No investigations are currently assigned to you.",
  },
  {
    routeName: "my-work.findings",
    path: "/my-work/findings",
    label: "Findings",
    tab: "assigned",
    source: "finding",
    emptyDescription: "No findings are currently assigned to you.",
  },
  {
    routeName: "my-work.capas",
    path: "/my-work/capas",
    label: "CAPAs",
    tab: "assigned",
    source: "capa",
    emptyDescription: "No CAPAs are currently assigned to you.",
  },
  {
    routeName: "my-work.control-tests",
    path: "/my-work/control-tests",
    label: "Control Tests",
    tab: "assigned",
    source: "control_test",
    emptyDescription: "No control tests are currently assigned to you.",
  },
  {
    routeName: "my-work.pending-reviews",
    path: "/my-work/pending-reviews",
    label: "Pending Reviews",
    tab: "reviews",
    emptyDescription: "Nothing is waiting on your review.",
  },
  {
    routeName: "my-work.pending-approvals",
    path: "/my-work/pending-approvals",
    label: "Pending Approvals",
    tab: "approvals",
    emptyDescription: "Nothing is waiting on your approval.",
  },
];
